import { Injectable } from '@angular/core';
import { SafeStyle, DomSanitizer } from '@angular/platform-browser';
import * as Library from '../../../lib/core/library/index';
import { isNil, isEmpty } from 'lodash';
import { NOT_APPLICABLE } from '../../shared/constants/app.constants';

@Injectable()
export class SharedFunctionService {
  constructor(public sanitization: DomSanitizer) { }

  getFormattedYearMarketingName(vehicleDetails: any) {
    if (!isNil(vehicleDetails)) {
      if (Library.isStringWithLength(vehicleDetails.model.marketingName)) {

        const firstPos = vehicleDetails.model.marketingName
          .toLowerCase()
          .indexOf(vehicleDetails.marketingSeries.toLowerCase());
        if (firstPos !== -1) {
          const lastPos = firstPos + vehicleDetails.marketingSeries.length;
          // if(mode === 'series') {
          //   return vehicleDetails.model.marketingName.substring(firstPos, lastPos);
          // } else if(mode === 'trim') {
          //   return vehicleDetails.model.marketingName.substring(lastPos);
          // }
          return (
            '<div><span class=\'dd-model-year\'>' + vehicleDetails.year + '</span>' +
            ' ' +
            vehicleDetails.model.marketingName.substring(0, firstPos) +
            '<span class="dd-model-name">' +
            vehicleDetails.model.marketingName.substring(firstPos, lastPos) +
            '</span></div>' +
            '<div class="dd-model-trim">' +
            vehicleDetails.model.marketingName.substring(lastPos) +
            '</div>'
          );
        } else {
          const tempName: Array<
            string
            > = vehicleDetails.model.marketingName.split(' ');
          if (!isNil(tempName[0])) {
            tempName[0] = '<span class=\'dd-model-name\'>' + tempName[0];
          }

          if (
            !isNil(tempName[1]) &&
            tempName[1].search(/((<([^>]+)>)|(&nbsp;))/gi) >= 0
          ) {
            if (!isNil(tempName[2])) {
              tempName[2] = '<div class=\'dd-model-trim\'>' + tempName[2];
            }
            tempName[tempName.length - 1] =
              tempName[tempName.length - 1] + '</div>';
          } else {
            if (!isNil(tempName[0])) {
              tempName[0] += '</span>';
            }
            if (!isNil(tempName[2])) {
              tempName[1] = '<div class=\'dd-model-trim\'>' + tempName[1];
            }
            tempName[tempName.length - 1] =
              tempName[tempName.length - 1] + '</div>';
          }
          return '<span class=\'dd-model-year\'>' + vehicleDetails.year + '</span>' + ' ' + tempName.join(' ');
        }
      }
    } else {
      return '';
    }
  }

  public getModelMarketingName(vehicleDetails: any) {
    let output = '';
    let tempName: Array<string>;
    if (
      !isNil(vehicleDetails) &&
      !isNil(vehicleDetails.model) &&
      !isNil(vehicleDetails.model.marketingName)
    ) {
      tempName = vehicleDetails.model.marketingName.split(
        ' '
      );
      if (!isNil(tempName[0])) {
        output = tempName[0];
      }
    }
    // Below code is to handle ebrochure broken link for c-hr
    // '-'  in the marketing name is not matching with url in toyota.com (ebrochure)
    if (output === 'C‑HR') {
      output = 'C-HR';
    } else if (output === 'Prius' && !isNil(tempName) && tempName.length >= 2
      && !isNil(tempName[1]) && tempName[1] === '<i>c</i>') { // To fix Prius C ebroucher link
      output += 'c';
    } else if (output === 'RAV4' && !isNil(tempName) && tempName.length >= 2
      && !isNil(tempName[1]) && tempName[1] === 'Prime') {
        output += 'prime';
    } else if (output === 'GR' && !isNil(tempName) && tempName.length >= 2
      && !isNil(tempName[1]) && tempName[1] === 'Supra') {
        output += '-supra';
      }
    return output;
  }
  public getModelTrimName(vehicleDetails: any) {
    let output = '';
    if (
      !isNil(vehicleDetails) &&
      !isNil(vehicleDetails.model) &&
      !isNil(vehicleDetails.model.marketingName)
    ) {
      const tempName: Array<string> = vehicleDetails.model.marketingName.split(
        ' '
      );
      if (!isNil(tempName[1])) {
        output = tempName[1];
      }
    }
    return output;
  }
  transform(style: string): SafeStyle {
    const formatedStyle = style?.split('|')[0];
    if (formatedStyle === '#undefined') {
      return 'url("../../../assets/icons/icon-x.svg")';
    }
    return this.sanitization.bypassSecurityTrustStyle(formatedStyle);
  }

  transformURL(url: string): SafeStyle {
    if (isNil(url)) {
      return 'url("../../../assets/icons/icon-x.svg")';
    }
    return this.sanitization.bypassSecurityTrustStyle('url(' + url + ')');
  }

  loadBase64DataFromImageURL(imageId: string, imageSrc: string, callback: Function) {
    let newImg: HTMLImageElement = null;
    if (!isNil(imageId)) {
      newImg = document.getElementById(imageId) as HTMLImageElement;
    }
    if (!isNil(imageSrc) && imageSrc !== '') {
      const corsApiUrl = 'https://cors-anywhere.herokuapp.com/';
      // let corsApiUrl = 'https://cryptic-headland-94862.herokuapp.com/';
      let imgCanvas: any = document.createElement('CANVAS');
      const img = document.createElement('img');
      img.setAttribute('crossOrigin', 'Anonymous');
      // Workaround - Without this additional query string, cloudfront is giving  No 'Access-Control-Allow-Origin'
      // header is present on the requested resource, the same works when the cache is disabled on browser, adding this
      // Additional Query string will simulate the same disable cache for the images. This looks to be an issue on cloudfront
      // Because the origin server is just allowing request from *.toyota.com and *.lexus.com, while most of them allow *.*
      // Check if the domain is toyota.com or lexus.com
      if (imageSrc.includes('.toyota.com') || imageSrc.includes('.lexus.com')) {
        // Append the additional query param if the domain is either toyota.com or lexus.com
        if(imageSrc.includes('?')){
          imageSrc = imageSrc.replace('?',"?x-request=vspec&");
        }else{
          imageSrc += '?x-request=vspec';
       }
      }
      img.src = imageSrc;
      img.onload = () => {
          imgCanvas.height = img.height;
          imgCanvas.width = img.width;
          const context = imgCanvas.getContext('2d');
          context.drawImage(img, 0, 0);
          const dataURL = imgCanvas.toDataURL('image/png');
          imgCanvas = null;
          if (!isNil(newImg)) {
              newImg.src = dataURL;
          }
          callback(dataURL);
      };
      img.onerror = () => {
          callback(null);
      };
    } else {
      callback(null);
    }
  }

  populateMpgValues(vehicleDetails: any) {
    const returnValue: any = { mpg: {}, mpge: {}, range: '' };
    if (vehicleDetails) {
      if ((!vehicleDetails.mpg && !vehicleDetails.mpge)
        || (isNil(vehicleDetails.mpg) && isNil(vehicleDetails.mpge))
        || (isEmpty(vehicleDetails.mpg) && isEmpty(vehicleDetails.mpge))) {
        returnValue.mpg.cityMpg = NOT_APPLICABLE;
        returnValue.mpg.highwayMpg = NOT_APPLICABLE;
        returnValue.mpg.combined = NOT_APPLICABLE;

        return returnValue;
      }

      if (isNil(vehicleDetails.mpge) || isEmpty(vehicleDetails.mpge)) {
        //Gas vehicle
        returnValue.mpg.cityMpg = vehicleDetails.mpg.city;
        returnValue.mpg.highwayMpg = vehicleDetails.mpg.highway;
        returnValue.mpg.combined = vehicleDetails.mpg.combined;
      } else if (isNil(vehicleDetails.mpg) || isEmpty(vehicleDetails.mpg)) {
        //Electric vehicle
        returnValue.mpge.cityMpge = vehicleDetails.mpge.city;
        returnValue.mpge.highwayMpge = vehicleDetails.mpge.highway;
        returnValue.mpge.combined = (vehicleDetails.mpge.combined && vehicleDetails.mpge.combined !== 0)
          ? vehicleDetails.mpge.combined
          : NOT_APPLICABLE;
        returnValue.range = vehicleDetails.mileage && vehicleDetails.mileage.range
          ? vehicleDetails.mileage.range
          : NOT_APPLICABLE;
      } else  {
        //Hybrid vehicle
        returnValue.mpg.combined = vehicleDetails.mpg.combined;
        returnValue.mpge.combined = vehicleDetails.mpge.combined;
        returnValue.range = vehicleDetails.mileage && vehicleDetails.mileage.range
          ? vehicleDetails.mileage.range
          : NOT_APPLICABLE;
      }
    }

    return returnValue;
  }
}
